<!-- 				-->
<!-- Confirm Dialog -->
<!-- 				-->
<p-confirmDialog [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<div class="main-group">
	<!--  	   	 	    -->
	<!-- HEADER SECTION -->
	<!-- 			    -->
	<div class="row-group" [style.display]="Visitor_PersonID < 0 ? 'block' : 'none'">
		<div class="row-item">
			<div style="margin-left: 20px">
				<label>Deny Entry for</label>
			</div>

			<div style="margin-left: 10px">
				<p-radioButton
					name="group1"
					[disabled]="UserLevelID != 1"
					value="1"
					label="All Sites"
					[(ngModel)]="selectedGroupValue"
					(ngModelChange)="onGroupChange($event)"
				></p-radioButton>
			</div>

			<div style="margin-left: 10px">
				<p-radioButton
					name="group1"
					value="2"
					label="Facility"
					[(ngModel)]="selectedGroupValue"
					(ngModelChange)="onGroupChange($event)"
				></p-radioButton>
			</div>

			<!--  	   	           -->
			<!-- Facility Selector -->
			<!-- 		           -->
			<div style="margin-left: 10px; width: 153px" [style.display]="selectedGroupValue == '2' ? 'block' : 'none'">
				<!-- Note: (ngModelChange) must go after [(ngModel)] or you get prev selected item!  -->
				<select
					class="form-control"
					name="SelectedFacilitySelector"
					style="font-size: smaller"
					[(ngModel)]="SelectedFacility"
					(ngModelChange)="onFacilityChange($event)"
				>
					<option *ngFor="let r of lstFacilityItems" [ngValue]="r">{{ r.FacilityCD }} - {{ r.FacilityName }}</option>
				</select>
			</div>
		</div>
	</div>

	<!--  	   	 	 -->
	<!-- TOP SECTION -->
	<!-- 			 -->
	<div class="column-group">
		<div class="column1">
			<!-- 	       -->
			<!-- FirstName -->
			<!-- 	       -->
			<div class="column-item">
				<div>
					<label class="column-item-label">First Name</label>
				</div>

				<div style="margin-left: 10px">
					<input type="text" pInputText [(ngModel)]="rFirstName" style="background-color: #ffdb7e" />
				</div>
			</div>
			<!-- 		  -->
			<!-- DOB Date -->
			<!-- 		  -->
			<div class="column-item">
				<div>
					<label class="column-item-label">DOB</label>
				</div>

				<div style="margin-left: 10px">
					<p-calendar
						[style]="{ width: '100%' }"
						[inputStyle]="{ width: '100%' }"
						[(ngModel)]="rDOB"
						(ngModelChange)="onDOBChange($event)"
						[showTime]="false"
						hourFormat="12"
						showIcon="true"
						inputId="rdob"
					></p-calendar>
				</div>
			</div>
			<!--  	   	 	             -->
			<!-- Visitor Status Selector -->
			<!-- 			             -->
			<div class="column-item">
				<div>
					<label class="column-item-label">Visitor Status</label>
				</div>

				<div style="margin-left: 10px; width: 153px">
					<!-- Note: (ngModelChange) must go after [(ngModel)] or you get prev selected item!  -->
					<select
						class="form-control"
						name="SelectedStatusSelector"
						style="font-size: smaller; background-color: #ffdb7e"
						[(ngModel)]="SelectedStatus"
						(ngModelChange)="onStatusChange($event)"
						[disabled]="isAllowStatusChange == false"
					>
						<option *ngFor="let r of lstStatusItems" [ngValue]="r" style="background-color: white">
							{{ r.VisitorStatusDesc }}
						</option>
					</select>
				</div>
			</div>
			<!--  	   	 	             -->
			<!-- Visitor Gender Selector -->
			<!-- 			             -->
			<div class="column-item">
				<div>
					<label class="column-item-label">Visitor Gender</label>
				</div>

				<div style="margin-left: 10px; width: 153px">
					<!-- Note: (ngModelChange) must go after [(ngModel)] or you get prev selected item!  -->
					<select
						class="form-control"
						name="SelectedGenderSelector"
						style="font-size: smaller"
						[(ngModel)]="SelectedGender"
						(ngModelChange)="onGenderChange($event)"
					>
						<option *ngFor="let r of lstGenderItems" [ngValue]="r">
							{{ r.GenderDesc }}
						</option>
					</select>
				</div>
			</div>
			<!-- 	        -->
			<!-- Hair Color -->
			<!-- 	        -->
			<div class="column-item">
				<div>
					<label class="column-item-label">Hair Color</label>
				</div>

				<div style="margin-left: 10px">
					<input type="text" pInputText [(ngModel)]="rHairColor" />
				</div>
			</div>
			<!-- 	       -->
			<!-- Eye Color -->
			<!-- 	       -->
			<div class="column-item">
				<div>
					<label class="column-item-label">Eye Color</label>
				</div>

				<div style="margin-left: 10px">
					<input type="text" pInputText [(ngModel)]="rEyeColor" />
				</div>
			</div>
		</div>

		<div class="column2">
			<!-- 	        -->
			<!-- MiddleName -->
			<!-- 	        -->
			<div class="column-item">
				<div>
					<label class="column-item-label">Middle Name</label>
				</div>

				<div style="margin-left: 10px">
					<input type="text" pInputText [(ngModel)]="rMiddleName" />
				</div>
			</div>
			<!-- 	    -->
			<!-- Height -->
			<!-- 	    -->
			<div class="column-item">
				<div>
					<label class="column-item-label">Height</label>
				</div>

				<div style="margin-left: 10px">
					<input type="text" pInputText [(ngModel)]="rHeight" />
				</div>
			</div>
			<!-- 	    -->
			<!-- Weight -->
			<!-- 	    -->
			<div class="column-item">
				<div>
					<label class="column-item-label">Weight</label>
				</div>

				<div style="margin-left: 10px">
					<input type="text" pInputText [(ngModel)]="rWeight" />
				</div>
			</div>
			<!-- 	   -->
			<!-- Photo -->
			<!-- 	   -->
			<div class="column-item" style="justify-content: center">
				<div class="image-view">
					<div [style.display]="Person_Image.length >= 10 ? 'block' : 'none'">
						<img class="image-view-img" [src]="Person_Image" />
					</div>
					<div [style.display]="Person_Image.length < 10 ? 'block' : 'none'">
						<label>No Image</label>
					</div>
				</div>
				<div style="margin-left: 10px">
					<!-- Image File Selector Button -->
					<label for="fileSelectImages" class="btn btn-primary" style="margin-left: 0px">...</label>
					<input
						id="fileSelectImages"
						type="file"
						(change)="onEditPhoto($event)"
						onclick="event.target.value=''"
						style="visibility: hidden; position: absolute"
						accept="image/*"
					/>
				</div>
			</div>
		</div>

		<div class="column3">
			<!-- 	      -->
			<!-- LastName -->
			<!-- 	      -->
			<div class="column-item">
				<div>
					<label class="column-item-label">Last Name</label>
				</div>

				<div style="margin-left: 10px">
					<input type="text" pInputText [(ngModel)]="rLastName" style="background-color: #ffdb7e" />
				</div>
			</div>
			<!--  	   	 	           -->
			<!-- Visitor Type Selector -->
			<!-- 			           -->
			<div class="column-item">
				<div>
					<label class="column-item-label">Visitor Type</label>
				</div>

				<div style="margin-left: 10px; width: 153px">
					<!-- Note: (ngModelChange) must go after [(ngModel)] or you get prev selected item!  -->
					<select
						class="form-control"
						name="SelectedTypeSelector"
						style="font-size: smaller"
						[(ngModel)]="SelectedType"
						(ngModelChange)="onTypeChange($event)"
					>
						<option *ngFor="let r of lstTypeItems" [ngValue]="r">
							{{ r.VisitorTypeDesc }}
						</option>
					</select>
				</div>
			</div>
			<!-- 	 -->
			<!-- SSN -->
			<!-- 	 -->
			<div class="column-item">
				<div>
					<label class="column-item-label">SSN</label>
				</div>

				<div style="margin-left: 10px">
					<input type="text" pInputText [(ngModel)]="rSSN" />
				</div>
			</div>
			<!--  	   	 	                -->
			<!-- Visitor Ethnicity Selector -->
			<!-- 			                -->
			<div class="column-item">
				<div>
					<label class="column-item-label">Visitor Ethnicity</label>
				</div>

				<div style="margin-left: 10px; width: 153px">
					<!-- Note: (ngModelChange) must go after [(ngModel)] or you get prev selected item!  -->
					<select
						class="form-control"
						name="SelectedEthnicitySelector"
						style="font-size: smaller"
						[(ngModel)]="SelectedEthnicity"
						(ngModelChange)="onEthnicityChange($event)"
					>
						<option *ngFor="let r of lstEthnicityItems" [ngValue]="r">
							{{ r.EthnicityDesc }}
						</option>
					</select>
				</div>
			</div>

			<!--  	   	 	           -->
			<!-- Visitor Race Selector -->
			<!-- 			           -->
			<div class="column-item">
				<div>
					<label class="column-item-label">Visitor Race</label>
				</div>

				<div style="margin-left: 10px; width: 153px">
					<!-- Note: (ngModelChange) must go after [(ngModel)] or you get prev selected item!  -->
					<select
						class="form-control"
						name="SelectedRaceSelector"
						style="font-size: smaller"
						[(ngModel)]="SelectedRace"
						(ngModelChange)="onRaceChange($event)"
					>
						<option *ngFor="let r of lstRaceItems" [ngValue]="r">
							{{ r.RaceDesc }}
						</option>
					</select>
				</div>
			</div>
		</div>
	</div>

	<!--  	   	 	    -->
	<!-- BOTTOM SECTION -->
	<!-- 			    -->
	<div class="column-group" style="margin-top: 20px; justify-content: center">
		<div class="column1">
			<!-- 	       -->
			<!-- Address 1 -->
			<!-- 	       -->
			<div class="column-item">
				<div>
					<label class="column-item-label">Address 1</label>
				</div>

				<div style="margin-left: 10px; width: 200px">
					<input type="text" pInputText [(ngModel)]="rStreet1" style="width: 250px" />
				</div>
			</div>
			<!-- 	       -->
			<!-- Address 2 -->
			<!-- 	       -->
			<div class="column-item">
				<div>
					<label class="column-item-label">Address 2</label>
				</div>

				<div style="margin-left: 10px">
					<input type="text" pInputText [(ngModel)]="rStreet2" style="width: 250px" />
				</div>
			</div>
			<!-- 	  -->
			<!-- City -->
			<!-- 	  -->
			<div class="column-item">
				<div>
					<label class="column-item-label">City</label>
				</div>

				<div style="margin-left: 10px">
					<input type="text" pInputText [(ngModel)]="rCity" style="width: 175px" />
				</div>
			</div>
			<!-- 	         -->
			<!-- State / ZIP -->
			<!-- 	         -->
			<div class="column-item">
				<div>
					<label class="column-item-label">State</label>
				</div>

				<div style="margin-left: 10px">
					<input type="text" pInputText [(ngModel)]="rState" style="width: 50px" />
				</div>

				<div>
					<label style="text-align: right; width: 50px">Zip</label>
				</div>

				<div style="margin-left: 10px">
					<input type="text" pInputText [(ngModel)]="rZip" style="width: 75px" />
				</div>
			</div>
		</div>

		<div class="column2">
			<!-- 	        -->
			<!-- Cell Phone -->
			<!-- 	        -->
			<div class="column-item">
				<div>
					<label class="column-item-label">Cell Phone</label>
				</div>

				<div style="margin-left: 10px">
					<input type="text" pInputText [(ngModel)]="rCellPhone" />
				</div>
			</div>
			<!-- 	        -->
			<!-- Home Phone -->
			<!-- 	        -->
			<div class="column-item">
				<div>
					<label class="column-item-label">Home Phone</label>
				</div>

				<div style="margin-left: 10px">
					<input type="text" pInputText [(ngModel)]="rHomePhone" />
				</div>
			</div>
			<!-- 	        -->
			<!-- Work Phone -->
			<!-- 	        -->
			<div class="column-item">
				<div>
					<label class="column-item-label">Work Phone</label>
				</div>

				<div style="margin-left: 10px">
					<input type="text" pInputText [(ngModel)]="rWorkPhone" />
				</div>
			</div>
			<!-- 	    -->
			<!-- e-mail -->
			<!-- 	    -->
			<div class="column-item">
				<div>
					<label class="column-item-label">e-mail</label>
				</div>

				<div style="margin-left: 10px">
					<input type="text" pInputText [(ngModel)]="rEmail" />
				</div>
			</div>
		</div>
	</div>

	<!--				-->
	<!-- Error Message  -->
	<!--				-->
	<div class="error-group">
		<div>
			<label class="error-message">{{ ErrorMessage }}</label>
		</div>
	</div>
</div>

<!-- 		 -->
<!-- Buttons -->
<!-- 		 -->
<div style="margin-top: 20px">
	<button class="btn btn-primary" style="margin-left: 0px" (click)="onUpdate()" [disabled]="isBusy == true">Update</button>
	<button class="btn btn-primary" style="margin-left: 5px" (click)="onClose()">Cancel</button>
</div>
